// Hook simples para inscrever realtime em uma tabela e disparar callback ao mudar
import { useEffect } from "react";
import { supabase } from "@/integrations/supabase/client";

type Table = "agents" | "workflow_runs" | "chat_messages" | "sandbox_runs" | "schedules";

export function useRealtime(
  table: Table,
  onChange: () => void,
  filter?: string,
) {
  useEffect(() => {
    const channel = supabase
      .channel(`realtime:${table}:${filter ?? "all"}`)
      .on(
        "postgres_changes",
        {
          event: "*",
          schema: "public",
          table,
          ...(filter ? { filter } : {}),
        },
        () => onChange(),
      )
      .subscribe();
    return () => {
      supabase.removeChannel(channel);
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [table, filter]);
}
